import { render, staticRenderFns } from "./sonalDetail.vue?vue&type=template&id=2ad3db4c&scoped=true&"
import script from "./sonalDetail.vue?vue&type=script&lang=js&"
export * from "./sonalDetail.vue?vue&type=script&lang=js&"
import style0 from "./sonalDetail.vue?vue&type=style&index=0&id=2ad3db4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad3db4c",
  null
  
)

export default component.exports